export const MODULE_NAME = "router";
export const APP_URL = "main";
export const DEFAULT_APP_URL = `/${APP_URL}/`;
export const LOGIN_URL = "/login";
